/**
 * Single source of truth for the Ring 2 (verified external sources) vocabulary.
 *
 * Ring 2 is the slice-5 "trusted Dutch GGZ content beyond Andre's curated
 * corpus" tier. Sources are crawled weekly into `kennisbank_ring2`; the
 * agent retrieves Ring 1 + Ring 2 in one pass and renders a Petrol chip
 * for Ring 2 citations next to the existing Mosterdgeel chip for Ring 1.
 *
 * Three consumers must agree on this list:
 *   - agents/kennisagent/data/ring2-sources.yml — Python crawler config
 *   - frontend citation chip rendering (label + tooltip)
 *   - backend audit context for crawl runs
 *
 * Adding a source is a code change everywhere it appears; that's the
 * point — Ring 2 vocabulary is small and clinical, not generic web crawl.
 *
 * v1: NHG, Trimbos, Thuisarts.nl, GGZ-standaarden, RIVM. Farmako deferred
 * to v1.1 (medication-info domain has separate citation/legal nuances).
 */
export const RING2_SOURCES = ['nhg', 'trimbos', 'thuisarts', 'ggz_standaarden', 'rivm'];
/** Display label for the citation chip + tooltip. Keep short. */
export const RING2_SOURCE_LABELS = {
    nhg: 'NHG',
    trimbos: 'Trimbos',
    thuisarts: 'Thuisarts.nl',
    ggz_standaarden: 'GGZ-standaarden',
    rivm: 'RIVM',
};
/** Set form for O(1) membership checks. */
export const RING2_SOURCES_SET = new Set(RING2_SOURCES);
//# sourceMappingURL=ring2-sources.js.map